
/*eslint-disable*/
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { check, commonApi } from '@/common/index';
import { ValidateRequire, checkOne } from '@/common/utils/validate.js'
export default {
name: 'findPassword',
components: {
XHeader,
Group,
XInput,
XButton,
Countdown,
},
data() {
return {
userName: '',
numberType: 1,
phoneOrEmail: '',
repeatPassword: '',
newPassword: '',
verifCode: '',


Email: '',
isReady: true,
showCountdown: true,
disabled: false,
start: false,
time: 60,
title: '手机',
}
},
created() {

this.disabled = true;
this.start = true;

this.UUID = this.$Cookies.get('UUID');
this.numberType = this.$route.query.numberType;
this.userName = this.$route.query.userName;
this.phoneOrEmail = this.$route.query.phoneOrEmail;
},
methods: {
finish() {
this.disabled = false;
this.start = false;
this.time = 60;
},
verifyEmail() {
if (!this.checkForm()) return
let params = {
username: this.userName,
numberType: this.numberType,
phoneOrEmail: this.phoneOrEmail,
verifyCode: this.verifCode,
password: this.newPassword,
repeatPassword: this.repeatPassword,
};
if (this.isReady) {
this.isReady = false;
commonApi.USER.confirm(params)
.then(data => {
this.isReady = true;
this.$vux.toast.show({ text: this.$t('forget').successTips2, type: 'success' });
let timer = setTimeout(() => {
this.$router.replace('/home')
clearTimeout(timer)
},2000)
})
.catch(err => {
this.isReady = true;
this.$vux.toast.show({ text: err, type: 'cancel' });
})
}
},
sendPhoneCode() {
this.disabled = true;
this.start = true;

let params = {
username: this.userName,
numberType: this.numberType,
phoneOrEmail: this.phoneOrEmail,
};
commonApi.USER.sendPhoneCode(params)
.then(data => {
this.$vux.toast.show({
text: this.$t('Forms').sendSuccess,
type: 'cancel'
});
})
.catch(err => {
this.$vux.toast.show({
text: err,
type: 'cancel'
});
})
},
checkForm() {
if(!ValidateRequire(this.verifCode)){
this.haveComTotas(this.$t('Forms').verifCodePlace)
return
}

if(!ValidateRequire(this.newPassword)){
this.haveComTotas(this.$t('Forms').newPwdPlace,'cancel')
return
}

if (!checkOne(this.newPassword)) {
this.haveComTotas(this.$t('Forms').pwdError,'cancel')
return
}

if(!ValidateRequire(this.repeatPassword)){
this.haveComTotas(this.$t('Forms').repeatPwdPlace,'cancel')
return
}

if(this.repeatPassword !== this.newPassword){
this.haveComTotas(this.$t('Forms').newDiff,'cancel')
return
}

return true
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/forgetPassword/findPassword.vue